// Lib
import React from 'react';

// Components
import BaseNotificationGroup from './BaseNotificationGroup';

const NotificationGroupGeneral = (props) => <BaseNotificationGroup {...props} className="NotificationGroupGeneral" />;

export default NotificationGroupGeneral;
